<template>
  <div class="row">
    <modal name="gestionar" :draggable="true" :scrollable="true" width="550" height="auto" :reset="true">
      <br />
      <div>
        <div>
          <div class="modal-header" style="padding-right: 5px; padding-top: 0">
            <div class="row">
              <div class="col-md-1">
                <i class="ti-settings text-success" style="font-size: 35px"></i>
              </div>
              <div class="col-md-7">
                <p class="titulo-modal" style="margin-bottom: -7px">
                  <strong>GESTIONAR USUARIOS</strong>
                </p>
                <!-- <small class="texto-pequeno" style="color:grey;">Gestionar la información de los usuarios</strong></small> -->
              </div>
            </div>
          </div>
          <div class="modal-body">
            <div class="row">
              <form @submit.prevent="actualizarUsuario">
                <div class="col-md-12">
                  <br />
                  <strong>Información de acceso:</strong>
                </div>
                 <div class="col-md-12">
                  <small>Firma electronica:</small>
                  <input type="text" class="form-control" v-model="usuarioActivo.UsuFirEle" />
                </div>
                <div class="col-md-12">
                  <small>Clave:</small>
                  <input type="text" class="form-control" v-model="clave" />
                </div>
                <div class="col-md-12">
                  <small>Correo:</small>
                  <input type="email" class="form-control" v-model="usuarioActivo.email" />
                </div>
                <div class="col-md-12" v-if="usuarioActivo.id_rol != 1">
                  <label for>Rol</label>
                  <select name v-model="usuarioActivo.id_rol" class="form-control">
                    <option :value="rol.id" v-for="rol in roles" :key="rol.id">
                      {{ rol.nombre }}
                    </option>
                  </select>
                  <br /><br />
                </div>


                <div class="col-md-12">
                  <br />
                  <strong>Firma</strong>
                </div>

                <div class="col-md-12">
                  <small>Campo 1:</small>
                  <input type="text" class="form-control" v-model="usuarioActivo.CamFir1" />
                </div>

                <div class="col-md-12">
                  <small>Campo 2:</small>
                  <input type="text" class="form-control" v-model="usuarioActivo.CamFir2" />
                </div>

                <div class="col-md-12">
                  <small>Campo 3:</small>
                  <input type="text" class="form-control" v-model="usuarioActivo.CamFir3" />
                </div>

                <div class="col-md-12">
                  <br />
                  <strong>Foto de perfil:</strong>
                </div>

                <div class="col-md-12">
                  <small>Seleccionar nueva foto de perfil:</small>
                  <input type="file" accept=".jpg, .png" @change="functionFotoPaciente" class="form-control" />
                </div>
                <div class="col-md-12">
                  <br />
                  <center>
                    <button type="submit" class="btn btn-success btn-fill btn-sm" style="border-radius: 5px">
                      Actualizar Datos <i class="fa fa-send"></i>
                    </button>
                  </center>
                </div>
              </form>
            </div>
          </div>
          <div class="modal-footer" style="padding-bottom: 0">
            <!-- <center> -->

            <button type="button" class="btn btn-danger btn-block btn-icon btn-simple" @click="cerrarModal()">
              <i class="fa fa-close"></i> CERRAR
            </button>
            <!-- </center> -->
          </div>
          <br />
        </div>
      </div>
    </modal>
   
    <div class="col-md-12 card" style="border-radius: 20px">
      <div class="card-content row">
        <div class="col-md-12" style="margin-bottom: 25px;">
      <p class="titulo-modal" style="margin-bottom: -1px">
        <strong style="font-size: 25px; font-weight: bold;">Usuarios registrados</strong>
      </p>
      <small class="texto-pequeno" style="color:grey;">Gestionar la información de los nuevos usuarios</small>
      
    </div>
    
        <div class="col-md-2">
          <button class="btn btn-default" style="border-radius: 5px" @click="estadoModalAgregar = 1">
            Nuevo Usuario <i class="fa fa-user"></i>
          </button>
        </div>




        <div class="col-sm-7">
          <input type="search" class="form-control" placeholder="Buscar usuario..." v-model="searchQuery"
            aria-controls="datatables" />
        </div>

        <div class="col-sm-3">
          <el-select class="select-default" v-model="pagination.perPage" placeholder="Per page">
            <el-option class="select-default" v-for="item in pagination.perPageOptions" :key="item" :label="item"
              :value="item"></el-option>
          </el-select>
        </div>

        <div class="col-sm-12">
          <br />
          <el-table class="table-striped" :data="queriedData" style="width: 100%">
            <el-table-column v-for="column in tableColumns" :key="column.label" :min-width="column.minWidth"
              :prop="column.prop" :label="column.label" else></el-table-column>
            <el-table-column :min-width="60" fixed="right" label="Estado">
              <template slot-scope="props">
                <center>
                  <div v-if="props.row.condicion == 1">
                    <span slot="title-label" class="label label-success" style="border-radius: 5px;">
                      <i class="ti-check"></i> Activo
                    </span>
                  </div>
                  <div v-else>
                    <span slot="title-label" class="label label-default" style="border-radius: 5px;">
                      <i class="ti-power-off"></i> Inactivo
                    </span>
                  </div>
                </center>
              </template>
            </el-table-column>
            <el-table-column :min-width="40" fixed="right" label="">
              <template slot-scope="props">
                <button v-if="props.row.condicion == 2 && props.row.usuario != 'kballeng'"
                  class="btn btn-simple btn-xs btn-info btn-icon check" @click="activar(props.row)">
                  <i class="ti-check"></i>
                </button>
                <button v-if="props.row.condicion == 1 && props.row.usuario != 'kballeng'"
                  class="btn btn-simple btn-xs btn-warning btn-icon edit" @click="desactivar(props.row)">
                  <i class="ti-close"></i>
                </button>
                <button class="btn btn-simple btn-xs btn-success" @click="abrirModal(props.row)">
                  <i class="fa fa-pencil"></i>
                </button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="col-sm-6 pagination-info">
          <br />
          <p class="category">
            Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
          </p>
        </div>
        <div class="col-sm-6">
          <p-pagination class="pull-right" v-model="pagination.currentPage" :per-page="pagination.perPage"
            :total="pagination.total"></p-pagination>
        </div>
      </div>
    </div>
    <!-- NUEVO USUARIO -->
    <div>
      <div class="modal fade" id="modalMotivo" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
        aria-hidden="true" style="padding:20px;" :class="{ mostrar: estadoModalAgregar }">
        <div class="modal-dialog" style="padding:10px;" role="document">
          <br>
          <div class="modal-content" style="padding:10px;">
            <!-- <div class="modal-header" style="padding: 8px">
              <strong class="modal-title" id="exampleModalLabel">
                <i class="fa fa-check-circle-o"></i> NUEVO USUARIO
              </strong>
              <button
                @click="estadoModalAgregar = 0"
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div> -->
            <div class="modal-header" style="padding-right: 5px; padding-top: 0">
              <div class="row">
                <br>
                <div class="col-md-1">
                  <i class="ti-user text-success" style="font-size: 35px"></i>
                </div>
                <div class="col-md-7">
                  <p class="titulo-modal" style="margin-bottom: -7px">
                    <strong>Nuevo usuario</strong>
                  </p>
                  <small class="texto-pequeno" style="color:grey;">Gestionar la información de los nuevos usuarios</small>
                </div>
              </div>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-md-6">
                  <label for>Nombres:</label>
                  <input v-model="nombres" class="form-control" />
                </div>
                <div class="col-md-6">
                  <label for>Apellidos:</label>
                  <input class="form-control" v-model="apellidos" />
                </div>
                <div class="col-md-6">
                  <label for>Usuario:</label>
                  <input class="form-control" v-model="usuario" />
                </div>
                <div class="col-md-6">
                  <label for>Contraseña:</label>
                  <input class="form-control" v-model="password" />
                </div>
                <div class="col-md-12">
                  <label for>Correo Avanza:</label>
                  <input class="form-control" v-model="confirmPassword" />
                </div>
                <div class="col-md-6">
                  <label for>Rol:</label>
                  <select name v-model="rol" class="form-control">
                    <option :value="rol.id" v-for="rol in roles" :key="rol.id">
                      {{ rol.nombre }}
                    </option>
                  </select>
                  <br /><br />
                </div>
                <div class="col-md-6">
                  <label for>Sede:</label>
                  <select name v-model="sede" class="form-control">
                    <option :value="sede.sede" v-for="sede in SedesProgramacion" :key="sede">
                      {{ sede.sede }}
                    </option>
                  </select>
                  <br /><br />
                </div>
                <center>
                  <div class="col-md-12" style="margin-bottom: 20px">
                    <button type="submit" style="border-radius: 5px;" @click="nuevoUsuario()" data-dismiss="modal"
                      class="btn btn-success btn-fill">
                      Agregar
                    </button>
                    <button type="button" style="border-radius: 5px;" class="btn btn-secondary btn-fill"
                      data-dismiss="modal" @click="estadoModalAgregar = 0">
                      Cancelar
                    </button>
                  </div>
                </center>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Table, TableColumn, Select, Option } from "element-ui";
import PPagination from "src/components/UIComponents/Pagination.vue";
import axios from "axios";
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Select);
Vue.use(Option);
export default {
  components: {
    PPagination,
  },
  computed: {
    pagedData() {
      return this.usuarios.slice(this.from, this.to);
    },
    /*
     * Searches through table data and returns a paginated array.
     * Note that this should not be used for table with a lot of data as it might be slow!
     * Do the search and the pagination on the server and display the data retrieved from server instead.
     * @returns {computed.pagedData}
     */
    queriedData() {
      if (!this.searchQuery) {
        this.pagination.total = this.usuarios.length;
        return this.pagedData;
      }
      let result = this.usuarios.filter((row) => {
        let isIncluded = false;
        for (let key of this.propsToSearch) {
          let rowValue = row[key].toString().toLowerCase();
          if (
            rowValue.includes &&
            rowValue.includes(this.searchQuery.toLowerCase())
          ) {
            isIncluded = true;
          }
        }
        return isIncluded;
      });
      this.pagination.total = result.length;
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      this.pagination.total = this.usuarios.length;
      return this.usuarios.length;
    },
  },
  data() {
    return {
      pagination: {
        perPage: 15,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },
      searchQuery: "",
      propsToSearch: ["nombres", "apellidos", "usuario", "condicion", "nombre"], //NOMBRE DE LOS CAMPOS POR LOS QUE DESEAS BUSCAR
      tableColumns: [
        {
          prop: "nombres", //NOMBRE DEL CAMPO TAL CUAL COMO ESTÁ EN LA BASE DE DATOS
          label: "Nombres", //NOMBRE QUE QUIERES QUE SE REFLEJE EN EL ENCABEZADO DE CADA COLUMNA
          // minWidth: 150, //ANCHO DE LA COLUMNA
        },
        {
          prop: "apellidos", //NOMBRE DEL CAMPO TAL CUAL COMO ESTÁ EN LA BASE DE DATOS
          label: "Apellidos", //NOMBRE QUE QUIERES QUE SE REFLEJE EN EL ENCABEZADO DE CADA COLUMNA
          // minWidth: 150, //ANCHO DE LA COLUMNA
        },
        {
          prop: "usuario",
          label: "Usuario",
          minWidth: 100,
        },
        {
          prop: "nombre",
          label: "Rol",
          // minWidth: 120,
        },
        {
          prop: "sede",
          label: "Sede",
          // minWidth: 120,
        },
      ],
      usuarios: [],
      // fotoPaciente: [],
      nombreFoto: "",
      fotoEnviar: [],
      ip: "https://avanti-erp.com/",
      estadoModalAgregar: 0,
      nombres: "",
      apellidos: "",
      usuario: "",
      password: "",
      confirmPassword: "",
      rol: "",
      sede: 'Sede Principal',
      usuarioActivo: [],
      clave: "",
      firmaElectronica: "",

      type: ["", "info", "success", "warning", "danger"],
      notifications: {
        topCenter: false,
      },
      SedesProgramacion: []
    };
  },
  methods: {
    abrirModal(usuario) {
      this.$modal.show("gestionar");
      this.usuarioActivo = usuario;
    },
    cerrarModal() {
      this.$modal.hide("gestionar");
      this.usuarioActivo = [];
    },
    cargarUsuarios() {
      var token = localStorage.getItem("token");
      var user = localStorage.getItem("usuario");
      axios
        .request({
          method: "get",
          baseURL: this.ip + "api/usuarios/" + user,
          headers: {
            Authorization: "Bearer " + token, //utilizacion de la variable que contiene el token
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          this.usuarios = response.data.data;
          // console.log(this.usuarios);
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    nuevoUsuario() {
      if (
        this.nombres == "" ||
        this.apellidos == "" ||
        this.usuario == "" ||
        this.password == "" ||
        this.rol == ""
      ) {
        var color = Math.floor(Math.random() * 4 + 1);
        this.$notify({
          component: {
            template: `<span><b>Faltan campos por llenar</b></span>`,
          },
          icon: "ti-close",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: this.type["warning"],
        });
      } else {
        var token = localStorage.getItem("token");
        axios
          .request({
            method: "post",
            baseURL: this.ip + "api/nuevoUsuario",
            data: {
              nombres: this.nombres,
              apellidos: this.apellidos,
              usuario: this.usuario,
              password: this.password,
              rol: this.rol,
              correo: this.confirmPassword,
              sede: this.sede
            },
            headers: {
              Authorization: "Bearer " + token, //utilizacion de la variable que contiene el token
              "Content-Type": "application/json",
            },
          })
          .then((response) => {
            var color = Math.floor(Math.random() * 4 + 1);
            this.$notify({
              component: {
                template: `<span><b>Usuario registrado con éxito </b></span>`,
              },
              icon: "ti-check",
              horizontalAlign: "right",
              verticalAlign: "top",
              type: this.type["success"],
            });
            this.cargarUsuarios();

            this.estadoModalAgregar = 0;
          })

          .catch(function (error) {
            console.log(error);
          });
      }
    },

    actualizarUsuario() {
      const BASE_URL = `${this.ip}api/actualizarUsuario`;
      let config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      axios
        .put(
          BASE_URL,
          {
            clave: this.clave,
            correo: this.usuarioActivo.email,
            tprofesional: this.usuarioActivo.tprofesional,
            cedula: this.usuarioActivo.cedula,
            id: this.usuarioActivo.id,
            rol: this.usuarioActivo.id_rol,
            foto: this.fotoEnviar,
            nombreFoto: this.nombreFoto,
            CamFir1: this.usuarioActivo.CamFir1,
            CamFir2: this.usuarioActivo.CamFir2,
            CamFir3: this.usuarioActivo.CamFir3,
            firmaElectronica: this.usuarioActivo.UsuFirEle
          },
          config
        )
        .then((res) => {
          if ((res.data.status = true)) {
            var color = Math.floor(Math.random() * 4 + 1);
            this.$notify({
              component: {
                template: ` <div style="padding: 3%;">
              <span><b> USUARIO ACTUALIZADO CON ÉXITO </b>.</span>
              </div>
              `,
              },
              icon: "ti-check",
              horizontalAlign: "right",
              verticalAlign: "top",
              type: this.type["success"],
            });
            this.cargarUsuarios();
            this.cerrarModal();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    functionFotoPaciente(e) {
      let reader = new FileReader();
      const fotoPaciente = e.target.files[0];
      this.nombreFoto = e.target.files[0].name;
      reader.readAsDataURL(fotoPaciente);
      reader.onload = (e) => {
        this.fotoEnviar = e.target.result;
      };
      // console.log(this.nombrefotoPaciente);
      console.log(this.fotoEnviar);
    },

    roles() {
      var token = localStorage.getItem("token");
      axios
        .request({
          method: "get",
          baseURL: this.ip + "api/roles",
          headers: {
            Authorization: "Bearer " + token, //utilizacion de la variable que contiene el token
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          this.roles = response.data.data;
          // console.log(this.roles);
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    desactivar(usuario = []) {
      // console.log(usuario);
      const BASE_URL = `${this.ip}api/desactivarUsuario`;
      let config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      axios
        .put(
          BASE_URL,
          {
            id: usuario.id,
          },
          config
        )
        .then((res) => {
          // console.log(res);
          if ((res.data.status = true)) {
            var color = Math.floor(Math.random() * 4 + 1);
            this.$notify({
              component: {
                template: ` <div style="padding: 3%;">
              <span><b> USUARIO INHABILITADO CON ÉXITO </b>.</span>
              </div>
              `,
              },
              icon: "ti-check",
              horizontalAlign: "right",
              verticalAlign: "top",
              type: this.type["success"],
            });
            this.cargarUsuarios();
          }
        })
        .catch((err) => {
          console.log(err);
          alert("Ocurrió un error, intentelo de nuevo");
        });
    },
    activar(usuario = []) {
      console.log(usuario);
      const BASE_URL = `${this.ip}api/activarUsuario`;
      let config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      axios
        .put(
          BASE_URL,
          {
            id: usuario.id,
          },
          config
        )
        .then((res) => {
          // console.log(res);
          if ((res.data.status = true)) {
            var color = Math.floor(Math.random() * 4 + 1);
            this.$notify({
              component: {
                template: ` <div style="padding: 3%;">
              <span><b> USUARIO HABILITADO CON ÉXITO </b>.</span>
              </div>
              `,
              },
              icon: "ti-check",
              horizontalAlign: "right",
              verticalAlign: "top",
              type: this.type["success"],
            });
            this.cargarUsuarios();
          }
        })
        .catch((err) => {
          console.log(err);
          alert("Ocurrió un error, intentelo de nuevo");
        });
    },

    emailsProgramacion: function () {
      let config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      };
      const BASE_URL = `${this.ip}api/emailsProgramacion`;
      axios
        .get(BASE_URL, config)
        .then(res => {
          let data = res.data.data;
          this.SedesProgramacion = data;
        })
        .catch(err => {
          console.log(err);
        });
    }
  },

  mounted() {
    document.title = "Avanti | Usuarios";
    this.cargarUsuarios();
    this.roles();
    this.emailsProgramacion();
  },
};

//NOTA: TODOS LOS CAMPOS EN LOS QUE VEAS QUE DICE usuarios, VAS A COLOCAR EL NOMBRE
//CON EL QUE DEFINISTE TU ARRAY.
</script>
<style scoped >
.mostrar {
  display: list-item !important;
  opacity: 2.5 !important;
  background-color: #3c29297a;
}

.modal-content {
  width: 100% !important;
  position: absolute !important;
  right: 0px;
  left: 2px;
}
</style>


// WEBPACK FOOTER //
// src/components/Acceso/usuarios.vue